import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from '@account-users/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private readonly auth: AuthService) {}

  canActivate() {
    if (!this.auth.isAuthenticated()) {
      console.warn('Token expired. Logging out!');
      this.auth.logout();
      return false;
    }
    return true;
  }
}
